// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"5e488a9d","308":"fdf6fddd","963":"dad5b4c2"}[chunkId] + ".chunk.js";
};